import { useMutation, useQuery } from '@tanstack/react-query'

import { RoutesPath, StorePersistKeys } from 'src/types'

import { useNavigation } from 'src/hooks/useNavigation'
import { useAppSelector } from 'src/hooks/useAppSelector'
import {
  addFuelTrackingHistory,
  deleteFuelTrackingHistoryItem,
  getAllFuelTrackingHistory,
  updateFuelTrackingHistory,
} from 'src/api/FuelTracking'

import { AddProps, UpdateProps } from 'src/api/FuelTracking/types'

export const useManageFuelHistory = () => {
  const { navigateTo } = useNavigation()
  const { activeCar } = useAppSelector(state => state.user)

  function goToCars(): void {
    navigateTo(RoutesPath.MY_CARS)
  }

  const carName = activeCar

  const { data: allFuelHistory, isLoading: isLoadingGetAllFuelHistory } =
    useQuery({
      queryKey: [StorePersistKeys.FUEL_HISTORY, carName],
      queryFn: () => getAllFuelTrackingHistory(carName),
      enabled: Boolean(carName),
    })

  const { mutate: addFuelHistory, isLoading: isLoadingAddFuelHistory } =
    useMutation({
      mutationKey: [StorePersistKeys.FUEL_HISTORY],
      mutationFn: (payload: AddProps) =>
        addFuelTrackingHistory({ ...payload, carName }, goToCars),
    })

  const { mutate: updateFuelHistory, isLoading: isLoadingUpdateFuelHistory } =
    useMutation({
      mutationKey: [StorePersistKeys.FUEL_HISTORY],
      mutationFn: (payload: UpdateProps) =>
        updateFuelTrackingHistory({ ...payload, carName }),
    })

  const { mutate: deleteFuelHistory, isLoading: isLoadingDeleteFuelHistory } =
    useMutation({
      mutationKey: [StorePersistKeys.FUEL_HISTORY],
      mutationFn: (id: string) =>
        deleteFuelTrackingHistoryItem({ id, carName }),
    })

  return {
    allFuelHistory,
    addFuelHistory,
    updateFuelHistory,
    deleteFuelHistory,
    isLoadingGetAllFuelHistory,
    isLoadingUpdateFuelHistory,
    isLoadingAddFuelHistory,
    isLoadingDeleteFuelHistory,
    isLoadingGeneral:
      isLoadingGetAllFuelHistory ||
      isLoadingAddFuelHistory ||
      isLoadingUpdateFuelHistory ||
      isLoadingDeleteFuelHistory,
  }
}
